export const CATEGORY_LIST = [
  {
    name: 'sneakers',
  },
  {
    name: 'apparels',
  },
  {
    name: 'handbags',
  },
  {
    name: 'lifestyles',
  },
  {
    name: 'madeindonesia',
  },
];

export const SNEAKERS_CONDITION = [
  {
    name: 'BARU',
  },
  {
    name: 'BEKAS',
  },
  {
    name: 'PREORDER',
  },
  {
    name: 'PREVERIFIED',
  },
  {
    name: 'PRISTINE',
  },
  {
    name: 'GOOD',
  },
  {
    name: 'WELL_USED',
  },
  {
    name: 'LIKE_NEW',
  },
  {
    name: 'VINTAGE',
  },
];

export const SNEAKERS_CONDITION_BRAND_PAGE = [
  {
    name: 'PREVERIFIED',
  },
  {
    name: 'BARU',
  },
  {
    name: 'BEKAS',
  },
  {
    name: 'PREORDER',
  },
];

export const SNEAKERS_CONDITION_LUXURY = [
  {
    name: 'PREVERIFIED',
  },
  {
    name: 'BARU',
  },
  {
    name: 'PRISTINE',
  },
  {
    name: 'GOOD',
  },
  {
    name: 'WELL_USED',
  },
  {
    name: 'LIKE_NEW',
  },
  {
    name: 'VINTAGE',
  },
  {
    name: "PREORDER"
  }
];

export const GENDER_LIST = [
  {
    name: 'M',
  },
  {
    name: 'F',
  },
  {
    name: 'GS',
  },
];
